export default __webpack_public_path__ + "static/media/rename.e9d61182.svg";